import Errors from './Errors.vue';

export default Errors;



// WEBPACK FOOTER //
// ./src/pages/profile/components/errors/index.ts